import React, { useState } from 'react';
import _, { isEmpty } from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import PaymentListApi from '../../service/payment.api';
import InvoiceListApi from '../../service/invoice.api';
import { addCommas } from '../../utils/functions/commas';
import { swalClose, swalConfirm, swalErrorBtn, swalErrorTimer, swalLoading } from '../../helpers/swalHelper';
import LinearLoading from '../LinearLoading';
import ManualDetailDialog from '../dialogs/payment/ManualDetailDialog';
import DetailDialog from '../dialogs/Invoice/DetailDialog';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Tooltip,
  Menu,
  MenuItem
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ReceiptIcon from '@mui/icons-material/Receipt';
import VerifiedIcon from '@mui/icons-material/Verified';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptDetailDialog from '../dialogs/payment/ReceiptDetailDialog';
import Swal from 'sweetalert2';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Checkbox from '@mui/material/Checkbox';

dayjs.extend(utc);

function TablePaymentList({
  paymentList,
  rowsPerPage,
  page,
  total,
  sort,
  setPage,
  setRowsPerPage,
  setSort,
  isLinearLoading,
  haveReceipt,
  havePdf,
  handleExportExcel
}) {
  const handleSort = (column) => {
    if (sort.column === column) {
      setSort({
        ...sort,
        direction: sort.direction === 'asc' ? 'desc' : 'asc',
      });
      setPage(0);
    } else {
      setSort({ direction: 'asc', column });
      setPage(0);
    }
  };

  const [showDialogDetail, setShowDialogDetail] = useState(false);
  const [nameAdmin, setNameAdmin] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const [menuRowOrderId, setMenuRowOrderId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const [openDialogDetail, setOpenDialogDetail] = useState(false)
  const [detailInvoice, setDetailInvoice] = useState([]);

  const [manualPayment, setManualPayment] = useState('');

  const [openReceiptDialog, setOpenReceiptDialog] = useState(false);
  const [showPDF, setShowPDF] = useState('');
  const [type, setType] = useState('receipt');

  const [selectedRows, setSelectedRows] = useState([]);

  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const openDetailDialog = async (order_id) => {
    try {
      const data = await InvoiceListApi.getInvoiceDetail(order_id);
      const resp = data?.data
      // console.log(resp)

      setDetailInvoice(resp);
      setOpenDialogDetail(true);
    } catch (error) {
      console.log('Error fetch data');
      swalErrorTimer({text: `เกิดข้อผิดพลาด ${error}`});
    }
  }

  const closeDetailDialog = () => {
    setOpenDialogDetail(false);
  }

  const handleShowDetail = async (orderId) => {
    try {
      const resp = await PaymentListApi.getManualPaidApi(orderId);
      setShowDialogDetail(true);

      setNameAdmin(resp?.updated_by);
      setDate(dayjs.utc(resp?.pay_date).format('YYYY-MM-DD'));
      setTime(dayjs.utc(resp?.pay_date).format('HH:mm:ss'));

    } catch (error) {
      console.error(error);
      swalErrorTimer({text: `เกิดข้อผิดพลาด ${error}`});
    }
  };

  const handleShowReceiptDialog = async (orderId) => {
    swalLoading({ title: 'กำลังเปิดไฟล์ PDF...' });
    try {
      const resp = await PaymentListApi.getReceiptApi(orderId);

      const base64 = resp?.base64;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);

      Swal.close();
      setType('receipt');
      setShowPDF(pdfUrl);
      setOpenReceiptDialog(true);
    } catch (error) {
      console.log("เกิดข้อผิดพลาด", error);
      swalErrorTimer({ text: `ไม่สามารถเปิดไฟล์ PDF ได้!` })
    }
  }

  const handleShowInvoiceDialog = async (orderId) => {
    swalLoading({ title: 'กำลังเปิดไฟล์ PDF...' });
    try {
      const resp = await InvoiceListApi.getPdfApi(orderId);

      const base64 = resp?.base64;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);

      Swal.close();
      setType('invoice');
      setShowPDF(pdfUrl);
      setOpenReceiptDialog(true);
    } catch (error) {
      console.log("เกิดข้อผิดพลาด", error);
      swalErrorTimer({ text: `ไม่สามารถเปิดไฟล์ PDF ได้!` })
    }
  }

  const closeReceiptDialog = () => {
    setOpenReceiptDialog(false);
  }

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      setSelectedRows(paymentList);
    } else {
      setSelectedRows([]);
    }
  }

  const isSelected = (rowId) => selectedRows.some((row) => row._id === rowId);

  const handleSelectRow = (row) => {
    if (isSelected(row._id)) {
      setSelectedRows(selectedRows.filter((r) => r._id !== row._id));
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };


  const toZipFile = async (blob) => {
    const url = window.URL.createObjectURL(new Blob([blob.data], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'receipt_pdf.zip');
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 2000);
  }


  const handleDowloadZipReceipt = async (selectedRows) => {
    if (isEmpty(selectedRows)) {
      swalErrorBtn({ title: `โปรดเลือกข้อมูลก่อนดาวน์โหลด` });
      return;
    }

    const confirm = await swalConfirm({ title: `ยืนยันการดาวน์โหลดไฟล์หรือไม่` });
    if (!confirm.isConfirmed) {
      return;
    }

    try {
      swalLoading({ title: `กำลังดาวโหลดไฟล์...` })
      const selectedOrderIds = selectedRows.map(row => row.order_id)
      const resp = await PaymentListApi.postZipReceiptApi(selectedOrderIds);
      toZipFile(resp);
      swalClose();
      setSelectedRows([])
    } catch (error) {
      console.log("error : ", error);
      swalErrorTimer({text: `ไม่สามารถโหลดใบเสร็จได้`})
    }
  }

  return (
    <div>
      <div className="flex-1">
        <div className="px-2 py-4">
          {/* Desktop view */}
          <Grid
            container
            spacing={2}
            sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' } }}
          >
            {/* Your table component here */}
            <TableContainer component={Paper}>
              { <LinearLoading isLinearLoading={isLinearLoading}/> }
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    { haveReceipt && (
                      <TableCell align="center">
                        <Checkbox
                          checked={selectedRows.length === paymentList.length}
                          onChange={(e) => handleSelectAllRows(e)}
                        />
                      </TableCell>)
                    }
                    <TableCell sx={{ width: '10%' }}>เลขที่ใบแจ้งหนี้</TableCell>
                    <TableCell sx={{ width: '15%' }}>ชื่อลูกค้า</TableCell>
                    <TableCell sx={{ width: '15%' }}>รายการ</TableCell>
                    <TableCell sx={{ width: '15%' }} align="center">
                      <TableSortLabel
                        active={sort.column === 'pay_date'}
                        direction={sort.direction || 'asc'}
                        onClick={() => handleSort('pay_date')}
                      >
                        วันที่ชำระเงิน
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="right" sx={{ width: '15%' }}>
                      <TableSortLabel
                        active={sort.column === 'total_amount'}
                        direction={sort.direction || 'asc'}
                        onClick={() => handleSort('total_amount')}
                      >
                        ยอดรับชำระเงิน
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center" sx={{ width: '15%' }}>
                      เลขที่อ้างอิงการชำระเงิน
                    </TableCell>
                    <TableCell align="center" sx={{ width: '15%' }}>
                      เลขอ้างอิงคำสั่งรับเงิน
                    </TableCell>
                    <TableCell align="center" sx={{ width: '15%' }}>
                      ช่องทาง
                    </TableCell>
                    <TableCell align="center" sx={{ width: '15%' }}>
                      ดูรายละเอียด
                    </TableCell>
                  </TableRow>
                </TableHead>
                {_.size(paymentList) ? (
                  <TableBody>
                    {paymentList.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        { haveReceipt && (
                          <TableCell align="center">
                            <Checkbox
                              checked={isSelected(row._id)}
                              onChange={() => handleSelectRow(row)}
                            />
                          </TableCell>
                        )}
                        <TableCell>{row.invoice_no || '-'}</TableCell>
                        <TableCell>{row.so_name || '-'}</TableCell>
                        <TableCell>{row.descriptions || '-'}</TableCell>
                        <TableCell align='center'>
                          {dayjs.utc(row.pay_date).format('YYYY-MM-DD HH:mm:ss')}
                        </TableCell>
                        <TableCell align="right">
                          {addCommas(row.total_amount, 2) || '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.payment_reference_id || '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.order_id || '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.pay_type || '-'}
                        </TableCell>
                        <TableCell>
                          <Tooltip title='เมนูเพิ่มเติม' arrow>
                            <span>
                              <IconButton
                                onClick={(event) => {
                                  handleMenu(event);
                                  setMenuRowOrderId(row.order_id);
                                  setManualPayment(row.pay_type);
                                }}
                                aria-controls={open ? 'account-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                              >
                                <MoreHorizIcon color="primary" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <div>ไม่มีข้อมูล</div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                rowsPerPage={rowsPerPage}
                page={page}
                count={total}
                onPageChange={(event, newPage) => {
                  setPage(newPage);
                }}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
              />
            </TableContainer>
          </Grid>
          {/* Mobile/Tablet view */}
          <Grid
            container
            spacing={2}
            sx={{ display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none' } }}
          >
            {paymentList.map((row, index) => (
              <Grid item xs={16} md={6} key={index}>
                <Card sx={{ height: '100%' }}>
                  <CardHeader
                    title={row.invoice_no}
                    subheader={row.so_name ? row.so_name : 'ไม่มีชื่อผู้ใช้บริการ'}
                    action={
                      <Checkbox
                        checked={isSelected(row._id)}
                        onChange={() => handleSelectRow(row)}
                      />
                    }
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                          รายการ:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {row.descriptions}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                          วันที่ชำระเงิน:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {dayjs.utc(row.pay_date).format('YYYY-MM-DD HH:mm:ss')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                          ยอดรับชำระเงิน:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {addCommas(row.total_amount, 2)}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                          เลขที่อ้างอิงการชำระเงิน:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {row.payment_reference_id}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                        เลขอ้างอิงคำสั่งรับเงิน:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {row.order_id}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                        ช่องทาง:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ textAlign: 'right' }}>
                          {row.pay_type}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ textAlign: 'center' }}>
                      <Grid item xs={12}>
                        <Button
                          onClick={(event) => {
                            handleMenu(event);
                            setMenuRowOrderId(row.order_id);
                            setManualPayment(row.pay_type);
                          }}
                          aria-controls={open ? 'account-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                        >
                          <span >ดูรายละเอียดเพิ่มเติม</span>
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            <Grid
              item
              md={12}
              sx={{ justifyContent: 'center', display: 'flex' }}
            >
              <TablePagination
                sx={{
                  width: 'auto',
                  marginRight: '8px',
                  '& .MuiTypography-caption': { display: 'none' },
                }}
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                rowsPerPage={rowsPerPage}
                page={page}
                count={total}
                labelRowsPerPage="Rows"
                onPageChange={(event, newPage) => {
                  setPage(newPage);
                }}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
              />
            </Grid>
          </Grid>
          <div className="flex justify-end mr-2 mt-4">
            {haveReceipt && (
              <Button
                color='info'
                sx={{ mr: 1 }}
                variant="contained"
                onClick={() => {handleDowloadZipReceipt(selectedRows)}}
              >
                ดาวน์โหลดใบเสร็จ {selectedRows.length} รายการ
              </Button>
            )}

            <Button
              sx={{ color: '#fff' }}
              variant="contained"
              onClick={handleExportExcel}
            >
              ดาวน์โหลด excel
            </Button>
          </div>

          <ManualDetailDialog
            showDialogDetail={showDialogDetail}
            setShowDialogDetail={setShowDialogDetail}
            nameAdmin={nameAdmin}
            date={date}
            time={time}
          />

          <DetailDialog
            open={openDialogDetail}
            onClose={closeDetailDialog}
            detailData={detailInvoice}
          />

          <ReceiptDetailDialog
            open={openReceiptDialog}
            onClose={closeReceiptDialog}
            URL={showPDF}
            type={type}
          />

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            onClick={handleCloseMenu}
            slotProps={{
              list: {
                'aria-labelledby': 'account-menu',
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {manualPayment === 'อื่นๆ' && (
              <MenuItem
                onClick={() => {
                  handleShowDetail(menuRowOrderId);
                }}
                style={{ gap: '8px' }}
              >
                <VerifiedIcon color='primary' /> รายละเอียดการชำระเงิน
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                openDetailDialog(menuRowOrderId);
              }}
              style={{ gap: '8px' }}
            >
              <DescriptionIcon color='primary'/> รายละเอียดใบแจ้งหนี้
            </MenuItem>

            {havePdf && (
              <MenuItem
                onClick={() => {
                  handleShowInvoiceDialog(menuRowOrderId);
                }}
                style={{ gap: '8px' }}
              >
                <PictureAsPdfIcon color='primary' /> ใบแจ้งหนี้
              </MenuItem>
            )}

            {haveReceipt && (
              <MenuItem
                onClick={() => {
                  handleShowReceiptDialog(menuRowOrderId);
                }}
                style={{ gap: '8px' }}
              >
                <ReceiptLongIcon color='primary'/> ใบเสร็จชำระเงิน
              </MenuItem>
            )}
          </Menu>

        </div>
      </div>
    </div>
  );
}

export default TablePaymentList;
